const release2023 = [
  {
    date: '2023-12-08',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문 리스트 조회 파라미터 길이 변경 <code>shop_ship_no (15 → 30)</code>
        </>,
        apis: [
          {
            method: 'POST',
            action: '/api/orders',
          }
        ]
      }
    ]
  },
  {
    date: '2023-11-28',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          쇼핑몰 계정 관리 내 별칭 기능 추가 지원
        </>,
        apis: [
          {
            method: 'GET',
            action: '/shops',
            detail:
            <>
              - 쇼핑몰 코드 조회 : <code>used=true</code> 설정 시 별칭 조회 가능<br />
            </>
          },
          {
            method: 'POST',
            action: '/shop/add',
            detail:
            <>
              - 쇼핑몰 계정 등록 : <code>seller_nick 파라미터 추가</code> 별칭 등록 가능<br />
            </>
          },
          {
            method: 'PATCH',
            action: '/shop/edit',
            detail:
            <>
              - 쇼핑몰 계정 수정 : <code>seller_nick 파라미터 추가</code> 별칭 수정 가능<br />
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2023-10-11',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          주문상태변경 API 파라미터 <code>status</code>에 허용 값 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/orders/status',
            detail: 
            <>
              주문상태변경시 보류상태의 주문건도 상태변경가능하도록 수정<br />
              - 기존: 주문재확인 상태의 주문건만 상태변경 가능 <br/>
              - 변경: 신규주문 상태변경 가능주문(주문보류, 주문재확인), 출고대기 상태변경 가능주문(출고보류, 주문재확인)
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2023-09-06',
    items: [
      {
        type: 'Removed',
        summary:
        <>
          - 상품정보제공고시(구) 항목 지원 종료로 인한 API 미지원<br/>
          - SKU상품: 등록/수정/상세조회 API v1.0, v1.1 <br/>
          - 온라인상품: 등록/수정/리스트조회/상세조회 API v1.0
        </>,
        apis: [
          {
            method: 'POST',
            action: '/api/stock/add',
          },
          {
            method: 'PUT',
            action: '/api/stock/edit',
          },
          {
            method: 'GET',
            action: '/api/stock/:sku_cd',
          },
          {
            method: 'POST',
            action: '/api/stock/add/v1.1',
          },
          {
            method: 'PUT',
            action: '/api/stock/edit/v1.1',
          },
          {
            method: 'GET',
            action: '/api/stock/:sku_cd/v1.1',
          },
          {
            method: 'POST',
            action: '/api/products/add',
          },
          {
            method: 'PUT',
            action: '/api/products/edit',
          },
          {
            method: 'POST',
            action: '/api/online/list',
          },
          {
            method: 'GET',
            action: '/api/products/:ol_shop_no',
          },
        ]
      }
    ]
  },
  {
    date: '2023-08-21',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          선택작업 등록 API 온라인상품 재판매 작업전송시 새상품으로 등록 work_type 추가
        </>,
        apis: [
          {
            method: 'POST',
            action: '/work/addWorkSelect',
            detail: 
            <>
              - work_type = <code>REGIST_PROD_NEW</code> 추가<br />
              - 판매중지 상품 재판매시 <code>새로운 쇼핑몰 코드</code>로 등록
            </>
          }
        ]
      }
    ]
  },
  {
    date: '2023-08-04',
    items: [
      {
        type: 'Docs',
        summary:
        <>
          주문 리스트 조회 API 문서 bundle_yn관련 start, length, bundle_yn 파라미터 설명 변경
        </>,
        apis: [
          {
            method: 'POST',
            action: '/orders',
          }
        ]
      } 
    ]
  },
  {
    date: '2023-07-31',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          온라인상품 등록/수정 API 추가이미지 10 지원<br/>
          - <code>기존 추가이미지 9 까지만 지원이되어 10 까지 추가</code><br />
          - <code>이미지2 → 추가이미지 1 .. 등으로 안내 문구 변경</code>
        </>,
        apis: [
          {
            method: 'POST',
            action: '/products/add/v1.1',
          },
          {
            method: 'PUT',
            action: '/products/edit/v1.1',
          }
        ]
      }
    ]
  },
  {
    date: '2023-06-28',
    items: [
      {
        type: 'Changed',
        summary:
        <>
          에러 응답 포멧 변경<br />
          error_code 와 message 가 있는경우 messages 로 메세지 결과 배열로 리턴되도록 수정
          <pre style={{ width: '500px' }}>
            <code>
              {`
              {
                error_code: 'e9999',
                messages: [
                  "에러 메세지"
                ]
              }
              `}
            </code>
          </pre>
        </>,
        apis: []
      }
    ]
  },
  {
    date: '2023-05-17',
    items: [
      {
        type: 'Added',
        summary:
        <>
          규칙 사은품 분배 API 추가
        </>,
        apis: [
          {
            method: 'PATCH',
            action: '/order/gift/distribution',
          }
        ]
      }
    ]
  },
  {
    date: '2023-03-28',
    items: [
      {
        type: 'Added',
        summary:
        <>
          공지사항 조회 API 추가
        </>,
        apis: [
          {
            method: 'GET',
            action: '/announcements',
          }
        ]
      }
    ]
  },
  {
    date: '2023-02-07',
    items: [
      {
        type: 'Added',
        summary:
        <>
          쇼핑몰 계정 삭제 API 추가
        </>,
        apis: [
          {
            method: 'DELETE',
            action: '/shop/delete',
          }
        ]
      },
      {
        type: 'Changed',
        summary:
        <>
          쇼핑몰 계정 등록/수정 API 전체 쇼핑몰 지원 <br />
          쇼핑몰별 etc필드 정보는 해당 API 문서의 엑셀 파일 참고
        </>,
        apis: [
          {
            method: 'POST',
            action: '/shop/add',
          },
          {
            method: 'PATCH',
            action: '/shop/edit',
          }
        ]
      },
    ]
  }
]

export default release2023;